import { IonToast } from "@ionic/react";
import { createContext, useContext, useState } from "react";

type ToastContextType = {
  showToast: (message: string) => void;
};

const ToastContext = createContext<ToastContextType>({
  showToast: () => {},
});

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [message, setMessage] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const showToast = (msg: string) => {
    setMessage(msg);
    setIsOpen(true);
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <IonToast
        isOpen={isOpen}
        onDidDismiss={() => setIsOpen(false)}
        message={message}
        duration={3000}
        color="danger"
        position="top"
      />
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
